import { RichTextEditor as MantineRichTextEditor } from "@mantine/tiptap"

import classNames from "./editor.module.css"

export const RichTextEditor = MantineRichTextEditor.extend({
  classNames,
})
